import { Hidden, Wrapper } from '@ahmdigital/ui';

import { ForwardButtonsWrapper, StyledButton, StyledWrapper } from './styles';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import ForwardButtons from '../forward-buttons';

type Props = {
  onNextClick?: Function;
};

const StepFooterNavigation = ({ onNextClick }: Props) => {
  const { analyticsLabel, goToPreviousStep, isFirstStep } = useByocNavigationContext();

  return (
    <Wrapper size="large">
      <StyledWrapper variant={['paddingTopSpacer8', 'paddingBottomSpacer10']}>
        <Hidden df lg>
          <ForwardButtons onNextClick={onNextClick} />
        </Hidden>
        {!isFirstStep && (
          <StyledButton
            analytics={{ label: `Back - ${analyticsLabel}` }}
            variant={['white', 'border']}
            onClick={goToPreviousStep}
          >
            Back
          </StyledButton>
        )}
        <Hidden xs sm md>
          <ForwardButtonsWrapper>
            <ForwardButtons onNextClick={onNextClick} />
          </ForwardButtonsWrapper>
        </Hidden>
      </StyledWrapper>
    </Wrapper>
  );
};

export default StepFooterNavigation;
